import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { t } from '@avanta/shared/i18n';
import { cn } from '@avanta/shared/utils/cn';
import { Pencil } from 'lucide-react';
import { useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';
import { EditAppointmentDialog } from './EditAppointmentDialog';
import { type LocationState, type EditAppointmentProps } from './types';

export const EditAppointment = ({
  appointment,
  from,
  icon,
  buttonLabel = t('EditAppointment.cta', { ns: LOCIZE_NS.APPOINTMENTS }),
  className,
}: EditAppointmentProps): React.ReactElement => {
  const { showDialog } = useDialogContext();
  const navigate = useNavigate();

  const handleEditClick = (): void => {
    const handleEditAppointment = (editState: LocationState): void => {
      navigate(ROUTES.APPOINTMENTS_RESERVE, { state: { ...editState, from } });
    };

    showDialog({
      component: (
        <EditAppointmentDialog appointment={appointment} onSuccess={handleEditAppointment} />
      ),
      state: { patientId: appointment.patientId },
    });
  };

  return (
    <Button
      variant="terciary"
      size="md"
      className={cn('hover:bg-green-100 hover:border-green-300 hover:text-green-700', className)}
      onClick={handleEditClick}
      icon={icon ?? 'leading'}
    >
      <Pencil className="size-3" />
      {icon !== 'only' && buttonLabel}
    </Button>
  );
};
